import { createContext } from "react";

/**
 * @typedef WidgetDisplayContext
 * @property {boolean} [open = false]
 * @property {function} [setOpen = () => {}]
 */

/**
 * @type {WidgetDisplayContext}
 */
const context = { open: false, setOpen: () => {} };

/**
 * context for the widget display.  mainly whether it's opened or closed
 */
export const DisplayContext = createContext(context);

export const DisplayProvider = DisplayContext.Provider;
